<template>
  <el-upload
    class="single-uploader"
    :action="uploadIp + '/job/uploadImages'"
    :show-file-list="false"
    :headers="headers"
    :on-success="handleSingleSuccess"
    :before-upload="beforeSingleUpload">
    <img v-if="imageUrl" :src="imageUrl" class="single">
    <i v-else class="el-icon-plus single-uploader-icon"></i>
  </el-upload>
</template>

<script>
import config from '@/utils/index'
export default {
  name: 'SingleUpload',
  props: {
    data: {
      type: String,
      default: () => {
        return ''
      }
    }
  },
  data() {
    return {
      uploadIp: config.uploadIp,
      imgIp: config.imgIp,
      imageUrl: ''
    }
  },
  computed: {
    headers() {
      return {
        Authorization: this.$store.state.user.token
      }
    }
  },
  mounted() {
    if (this.data) {
      this.imageUrl = this.imgIp + this.data
    }
  },
  methods: {
    handleSingleSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
      this.$emit('uploadSuccess', res.data.imageId)
    },
    beforeSingleUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!');
        return false
      }
      let fileType = file.name.substring(file.name.lastIndexOf(".") + 1);
      if (fileType.toLowerCase() === 'png' || fileType.toLowerCase() === 'jpg' || fileType.toLowerCase() === 'jpeg') {
        return true
      } else {
        this.$message.error('上传图片格式只支持png,jpg,jpeg格式');
        return false
      }
    }
  }
}
</script>

<style lang="scss">
.single-uploader {
  .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    &:hover {
      border-color: #409EFF;
    }
  }
  .single-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 78px;
    height: 78px;
    line-height: 78px;
    text-align: center;
  }
  .single {
    width: 78px;
    height: 78px;
    display: block;
  }
}
</style>
